module.exports = __webpack_public_path__ + "img/ying.c94f88fc.png";